import React from "react";
//#region types
import { FileViewerInnerProps, FileViewerPDFState } from "models/propTypes/fileViewerPropTypes";
//#endregion
//#region components
import NoImage from "images/no_image.png";
import { Document, Page } from "react-pdf";
import LoadingWithLogo from "../loading/loadingWithLogo";
import { FileViewerContext } from "components/common/fileViewer/context";
//#endregion
import * as Sentry from "@sentry/react";
import cssExports from "theme/styles/main.module.scss";

// pdf.js fetches its OpenJPEG wasm decoder from wasmUrl; without it JPEG 2000 images render blank.
// Module-level so react-pdf doesn't see a new options object (and reload the document) on every render.
const pdfOptions = { wasmUrl: `${import.meta.env.BASE_URL}pdfjs-wasm/` };

class FileViewerPDF extends React.Component<FileViewerInnerProps, FileViewerPDFState> {
  static contextType = FileViewerContext;
  context!: React.ContextType<typeof FileViewerContext>;

  mounted: boolean = true;

  constructor(props: FileViewerInnerProps) {
    super(props);

    this.state = {
      currentWidth: 0,
      currentHeight: 0,
      numOfPages: 0,
    };
  }

  componentDidMount() {
    if (!this.props.fullScreen && this.context?.setUploadedFileDimensions) {
      this.context.setUploadedFileDimensions({ width: undefined, height: undefined });
    }
    this.mounted = true;
  }

  componentWillUnmount() {
    this.mounted = false;
  }

  shouldComponentUpdate(nextProps: FileViewerInnerProps, nextState: FileViewerPDFState) {
    return (
      this.props.currentPage !== nextProps.currentPage ||
      this.props.currentFile.data !== nextProps.currentFile.data ||
      this.props.containerWidth !== nextProps.containerWidth ||
      this.props.containerHeight !== nextProps.containerHeight ||
      this.state.numOfPages !== nextState.numOfPages ||
      this.state.currentHeight !== nextState.currentHeight ||
      this.state.currentWidth !== nextState.currentWidth
    );
  }

  onDocumentLoadSuccess = (pdf: any) => {
    if (this.state.numOfPages !== pdf.numPages) {
      this.setState({
        numOfPages: pdf.numPages,
        currentWidth: this.props.containerWidth,
        currentHeight: this.props.containerHeight,
      });
    }
  };

  render() {
    return !this.props.isLoading && this.props.currentFile.data ? (
      <Document
        file={{ data: Uint8Array.from(atob(this.props.currentFile.data), (c) => c.charCodeAt(0)) }}
        onLoadSuccess={this.onDocumentLoadSuccess}
        options={pdfOptions}
        loading={
          <div style={{ width: this.props.containerWidth, height: this.props.containerHeight }}>
            <LoadingWithLogo />
          </div>
        }
        error={<img src={NoImage} style={{ width: this.props.containerWidth }}></img>}
        className={cssExports.pdfFileContainer}
      >
        {Array.from(new Array(this.state.numOfPages), (el, index) => (
          <Page
            key={`page_${index}`}
            pageNumber={index + 1}
            width={this.state.currentWidth}
            height={this.state.currentHeight}
            loading={
              <div style={{ width: this.props.containerWidth, height: this.props.containerHeight }}>
                <LoadingWithLogo />
              </div>
            }
            error={<img src={NoImage} style={{ width: this.props.containerWidth }} />}
            onLoadError={(error) => Sentry.captureException(error)}
            renderAnnotationLayer={false}
            renderTextLayer={false}
          />
        ))}
      </Document>
    ) : (
      <></>
    );
  }
}

export default FileViewerPDF;
